import { CustomerPortalPermission } from "@shared/enums/CustomerPortalPermission";
import { PermissionAccess, PermissionPage } from "@shared/models/permission";

export const permissionPageMap: PermissionPage[] = [
    {
        permission: CustomerPortalPermission.Dashboard,
        pathname: '/'
    },
    {
        permission: CustomerPortalPermission.Dashboard,
        pathname: '/callback-requests'
    }
]

export const checkPermissionAccess = (pathname: string, permissions: PermissionAccess[]): boolean => {
    const mapping = permissionPageMap.find(m => m.pathname === pathname);
    if (!mapping) return false;
    
    return permissions.some(p => p.name === mapping.permission);
}
